package org.vreo.devicehub.features.roi.presentation

import androidx.compose.ui.geometry.Offset
import org.vreo.devicehub.features.core.domain.device.roi.Roi

/**
 * Roi view actions
 */
sealed interface RoiActions {
    data object OnClearError : RoiActions
    data object OnSaveRoi : RoiActions
    data object OnRefreshImage : RoiActions
    data object OnDismissRoiEditor : RoiActions
    data object OnAddRoi : RoiActions
    data class OnClickedRoi(val roi: Roi?) : RoiActions
    data class OnClickedEditRoi(val roi: Roi) : RoiActions
    data class OnUpdateRoiDetails(val roi: Roi) : RoiActions
    data class OnUpdateRoiPoints(val id: Int, val points: List<Offset>) : RoiActions
    data class OnDeleteRoi(val id: Int) : RoiActions


}